
	import {
		Component,
		Vue
	} from 'vue-property-decorator';

	import customerOrderData from './components/customer-order-data.vue';
	import customerVisitData from './components/customer-visit-data.vue';

	@Component({
		name: 'customer-statistic',
		components: {
			customerOrderData,
			customerVisitData
		}
	})
	export default class CustomerStatistic extends Vue {

		private tab = 'tab1';

		private mounted() {
			
		}



		
	}
